/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Or_EmailInputs */

const cs_auth_or_email = /** @type {(inputs: Auth_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nebo e-mailem`)
};

const en_auth_or_email = /** @type {(inputs: Auth_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or sign in with email`)
};

/**
* | output |
* | --- |
* | "or sign in with email" |
*
* @param {Auth_Or_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_or_email = /** @type {((inputs?: Auth_Or_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Or_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_or_email(inputs)
	return cs_auth_or_email(inputs)
});